module.exports = __webpack_public_path__ + "static/media/oh_pack2_sample006_0004.56329d50.png";